import { useEffect, useRef } from "react";
import { loadDotLottie } from "@/lib/loadDotLottie";

type DotLottieCanvasProps = {
  src: string;
  width?: number;
  height?: number;
  autoplay?: boolean;
  loop?: boolean;
  speed?: number;
  className?: string;
};

export function DotLottieCanvas({
  src,
  width = 320,
  height = 320,
  autoplay = true,
  loop = true,
  speed = 1,
  className,
}: DotLottieCanvasProps) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    let player: any;
    let cancelled = false;

    loadDotLottie()
      .then(({ DotLottie }) => {
        if (cancelled || !canvasRef.current) return;
        canvasRef.current.width = width;
        canvasRef.current.height = height;
        player = new DotLottie({
          canvas: canvasRef.current,
          autoplay,
          loop,
          speed,
          src,
          renderConfig: {
            autoResize: true,
            devicePixelRatio: window.devicePixelRatio || 1,
          },
        });
      })
      .catch((error) => {
        console.error("Failed to initialize dotlottie player", error);
      });

    return () => {
      cancelled = true;
      if (player) {
        try {
          player.destroy();
        } catch (error) {
          console.warn("Failed to destroy dotlottie player", error);
        }
      }
    };
  }, [autoplay, height, loop, speed, src, width]);

  return <canvas ref={canvasRef} className={className} style={{ width, height }} />;
}
